import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AboutMFOService {
  private setupDataCollection = new BehaviorSubject<any[]>([]);
  public handleSetupDataCollection = this.setupDataCollection;

  constructor() {}

  updateSetupData(data: any[]) {
    this.setupDataCollection.next(data);
  }

  getSetupData() {
    return this.setupDataCollection.getValue();
  }
}
